<script setup>
import { DropdownMenuTrigger } from 'radix-vue'

const props = defineProps({
  asChild: { type: Boolean, default: false },
  class: { type: String, default: '' },
})
</script>

<template>
  <DropdownMenuTrigger v-bind="props" class="outline-none">
    <slot />
  </DropdownMenuTrigger>
</template>
